import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";  // Import Link instead of useNavigate
import crossIcon from "../assets/cross.png";  // Path to your cross icon
import "../css/PayNow.css"
// import bgthanks from '../images/thanks-bg.webp'
import { useSelector } from "react-redux";
import Header from "../component/Header";
import Footer from "../component/Footer";

const RepayThankyou = () => {
  const location = useLocation();  // Hook to access the state passed via navigate
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const customerDetails = useSelector((state) => state?.customerJourneyDetails?.customerDetails);
  

  // Extract txnStatus and txnId from location state
  const { txnStatus, txnId } = location.state || {};

  // Determine if the transaction was successful
  const isTransactionSuccessful = txnStatus === 'SUCCESS' || txnStatus === 'success';

  // Set the button color based on txnStatus (green for success, red for failure)
  const buttonStyle = isTransactionSuccessful
    ? { backgroundColor: '#4CAF50' }  // Green for success
    : { backgroundColor: 'red' };  // Red for failure

  useEffect(() => {
    const token = customerDetails?.token;
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);

  return (
    <>
   
    <Header/>
  
      <div className="thank-you-content">
        <div
          className="icon1"
          style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 20px',
            backgroundColor: isTransactionSuccessful ? '#8cd9a2' : '#fff',  // Green for success, red for failure
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          {/* Conditionally render the success or cross icon */}
          {isTransactionSuccessful ? (
            <img
              src="https://img.icons8.com/ios-filled/100/ffffff/checked--v1.png"
              alt="Success Icon"
              style={{ width: '50%' }}
            />
          ) : (
            <img
              src={crossIcon}
              alt="Failure Icon"
              style={{ width: '50%' }}
            />
          )}
        </div>
        <div className="thank-you-message">
          {/* Conditionally render Thank You or Oops message */}
          {isTransactionSuccessful ? (
            <h2>Thank You!</h2>
          ) : (
            <h2 style={{ color: 'red' }}>Oops!</h2>  // Red color for failure
          )}
          <p>Your payment was {txnStatus || "NA"}.</p>
        </div>
        <div className="redirect-info">
          <p>Your Transaction ID is: {txnId || "N/A"}</p>
          <p>Transaction Status: {txnStatus || "NA"}</p>
        </div>
        {/* Apply the conditional style to the button and handle click */}
        <a href={isLoggedIn ? "/journey/dashboard" : "/"} className="thank-you-button" style={buttonStyle}>
          Go to {isLoggedIn ? 'Dashboard' : 'Home'}
        </a>
      </div>
    
    <Footer/>
</>
  );
};

export default RepayThankyou;
